<template>
  <div class="comp-xl-repeat-button">
    <jw-button class="text-button" size="small" type="outline" @click="openDialog">
      <template #icon v-if="(props.showType == 0 || props.showType == 1) && props.icon">
        <component :is="props.icon" />
      </template>
      <template v-if="props.showType == 0 || props.showType == 2">
        <span class="universal-text" :title="props.text"> {{ props.text }}</span>
      </template>
    </jw-button>
    <jw-modal :visible="visible" @cancel="handleCancel" :mask-closable="false" :footer="false" title-align="start" width="1200px" :title="$t('数据查重')" :body-style="{ height: '600px', display: flex, 'flex-direction': column }">
      <jw-space fill direction="vertical" size="large">
        <div>
          <jw-space fill direction="vertical" size="small">
            <jw-radio-group v-model="data.radio" @change="clearContent">
              <jw-radio value="companyName" style="margin-right: 10px">{{ $t('公司名称') }}</jw-radio>
              <jw-radio value="mobile">{{ $t('联系方式') }}</jw-radio>
            </jw-radio-group>
            <jw-textarea
              :auto-size="{
                minRows: 3,
                maxRows: 6
              }"
              v-model.trim="data.content"
              :placeholder="$t('tips.repeatAlert')"
              allow-clear
            />
            <div style="float: right">
              <jw-button @click="reset" style="margin-right: 10px">{{ $t('重置') }}</jw-button>
              <jw-button type="primary" @click="handleOk" :disabled="!data.content" :loading="loading">{{ $t('查重') }}</jw-button>
            </div>
          </jw-space>
        </div>
        <jw-tabs @tab-click="changeTab">
          <jw-tab-pane key="1" v-if="props.repeat == '1'" :title="`${$t('线索')}(${tProps?.pagination?.total})`">
            <xl-table :bordered="{ wrapper: true, cell: true }" v-on="tPropsEvent" :loading="loading" v-bind="tProps" :columns="data.columns">
              <!-- 客户名称 -->
              <template #customerId="{ record }">
                <!-- <jw-link v-if="record.customerName">{{ record.customerName }}</jw-link>
                <template v-else>- </template> -->
                <span>{{ record.customerName || '-' }}</span>
              </template>
              <!-- 商机名称 -->
              <template #opportunityId="{ record }">
                <!-- <jw-link v-if="record.opportunityName">{{ record.opportunityName }}</jw-link>
                <template v-else>- </template> -->
                <span>{{ record.opportunityName || '-' }}</span>
              </template>
              <!-- 关单日期-->
              <template #estimateCloseDate="{ record }">
                <span>{{ record?.estimateCloseDate || '-' }}</span>
              </template>
              <!-- 业务归属区域-->
              <template #businessRegion="{ record }">
                <span>{{ record?.businessRegion || '-' }}</span>
              </template>
              <!-- 商机来源-->
              <template #opportunitySource="{ record }">
                <span>{{ record?.opportunitySource || '-' }}</span>
              </template>

              <!-- 商机阶段-->
              <template #opportunityStage="{ record }">
                <jw-tag v-if="record.opportunityStage" :color="record.opportunityStage == '赢单' ? 'green' : record.opportunityStage == '丢单' ? 'red' : record.opportunityStage == '无效' ? 'gray' : 'purple'" size="small">{{ record.opportunityStage }}</jw-tag>
                <template v-else>-</template>
              </template>
              <!-- 负责人插槽 -->
              <template #chargePerson="{ record }">
                <xl-avatar v-if="record.chargePerson" :avatar="{ name: record?.chargePersonName || '', url: record?.chargePersonAvatar, id: record?.chargePerson }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 客户级别 -->
              <template #customer_level="{ record }">
                <jw-tag bordered color="cyan" v-if="record?.custom?.customer_level === 'A类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <jw-tag bordered color="arcoblue" v-else-if="record?.custom?.customer_level === 'B类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <jw-tag bordered color="pinkpurple" v-else-if="record?.custom?.customer_level === 'C类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <template v-else>-</template>
              </template>
              <!-- 跟进建议 插槽 -->
              <template #intentionality="{ record }">
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[3]" v-if="record?.custom?.intentionality === '待处理'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[0]" v-else-if="record?.custom?.intentionality === '建议转化'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[1]" v-else-if="record?.custom?.intentionality === '建议无效'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[2]" v-else-if="record?.custom?.intentionality === '待定'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[4]" v-else-if="record?.custom?.intentionality">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <template v-else>-</template>
              </template>
              <!-- 跟进人插槽 -->
              <template #followUser="{ record }">
                <xl-avatar v-if="record.followUser" :avatar="{ name: record?.followUserName || '', url: record?.followUserAvatar, id: record?.followUser }" :size="22" />
                <template v-else> - </template>
              </template>
              <!-- 创建人插槽 -->
              <template #createUser="{ record }">
                <xl-avatar v-if="record.createUser" :avatar="{ name: record?.createUserName || '', url: record?.createUserAvatar, id: record?.createUser }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 最后更新人插槽 -->
              <template #updateUser="{ record }">
                <xl-avatar v-if="record.updateUser" :avatar="{ name: record?.updateUserName || '', url: record?.updateUserAvatar, id: record?.updateUser }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 产品apaas -->
              <template #product_apaas="{ record }">
                <template v-if="record?.custom?.product_apaas">
                  <jw-tooltip position="right" mini>
                    <template #content>
                      <p v-for="(item, index) in record.custom?.product_apaas?.split(',')" :key="index">
                        {{ item }}
                      </p>
                    </template>
                    <div class="product-apaas-list">
                      <span v-for="(item, index) in record.custom?.product_apaas?.split(',')" :key="index">
                        <jw-tag bordered style="margin-right: 5px" :color="tagColors?.[index]">
                          {{ item }}
                        </jw-tag>
                      </span>
                    </div>
                  </jw-tooltip>
                </template>
                <template v-else>-</template>
              </template>
              <!-- 最后跟进内容 -->
              <template #lastFollowContent="{ record }">
                <template v-if="record?.lastFollowContent">{{ tools.stripMarkdown(record?.lastFollowContent) }}</template>
                <template v-else>-</template>
              </template>
            </xl-table>
          </jw-tab-pane>
          <jw-tab-pane key="2" :title="`${$t('客户')}(${tPropsCustom?.pagination?.total})`">
            <xl-table :bordered="{ wrapper: true, cell: true }" v-on="tPropsEventCustom" :loading="loading" v-bind="tPropsCustom" :columns="data.columnsCustom">
              <!-- 商机名称 -->
              <template #opportunityId="{ record }">
                <jw-link v-if="record.opportunityName">{{ record.opportunityName }}</jw-link>
                <template v-else>- </template>
              </template>
              <!-- 关单日期-->
              <template #estimateCloseDate="{ record }">
                <span>{{ record?.estimateCloseDate || '-' }}</span>
              </template>
              <!-- 业务归属区域-->
              <template #businessRegion="{ record }">
                <span>{{ record?.businessRegion || '-' }}</span>
              </template>
              <!-- 商机来源-->
              <template #opportunitySource="{ record }">
                <span>{{ record?.opportunitySource || '-' }}</span>
              </template>

              <!-- 商机阶段-->
              <template #opportunityStage="{ record }">
                <jw-tag v-if="record.opportunityStage" :color="record.opportunityStage == '赢单' ? 'green' : record.opportunityStage == '丢单' ? 'red' : record.opportunityStage == '无效' ? 'gray' : 'purple'" size="small">{{ record.opportunityStage }}</jw-tag>
                <template v-else>-</template>
              </template>
              <!-- 负责人插槽 -->
              <template #chargePerson="{ record }">
                <xl-avatar v-if="record.chargePerson" :avatar="{ name: record?.chargePersonName || '', url: record?.chargePersonAvatar, id: record?.chargePerson }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 客户级别 -->
              <template #customer_level="{ record }">
                <jw-tag bordered color="cyan" v-if="record?.custom?.customer_level === 'A类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <jw-tag bordered color="arcoblue" v-else-if="record?.custom?.customer_level === 'B类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <jw-tag bordered color="pinkpurple" v-else-if="record?.custom?.customer_level === 'C类'">
                  {{ record.custom.customer_level }}
                </jw-tag>
                <template v-else>-</template>
              </template>
              <!-- 跟进建议 插槽 -->
              <template #intentionality="{ record }">
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[3]" v-if="record?.custom?.intentionality === '待处理'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[0]" v-else-if="record?.custom?.intentionality === '建议转化'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[1]" v-else-if="record?.custom?.intentionality === '建议无效'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[2]" v-else-if="record?.custom?.intentionality === '待定'">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <xl-dot :title="record?.custom.intentionality" :color="data.colors[4]" v-else-if="record?.custom?.intentionality">
                  {{ record.custom.intentionality }}
                </xl-dot>
                <template v-else>-</template>
              </template>
              <!-- 跟进人插槽 -->
              <template #followUser="{ record }">
                <xl-avatar v-if="record.followUser" :avatar="{ name: record?.followUserName || '', url: record?.followUserAvatar, id: record?.followUser }" :size="22" />
                <template v-else> - </template>
              </template>
              <!-- 创建人插槽 -->
              <template #createUser="{ record }">
                <xl-avatar v-if="record.createUser" :avatar="{ name: record?.createUserName || '', url: record?.createUserAvatar, id: record?.createUser }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 最后更新人插槽 -->
              <template #updateUser="{ record }">
                <xl-avatar v-if="record.updateUser" :avatar="{ name: record?.updateUserName || '', url: record?.updateUserAvatar, id: record?.updateUser }" :size="22" />
                <template v-else>-</template>
              </template>
              <!-- 产品apaas -->
              <template #product_apaas="{ record }">
                <template v-if="record?.custom?.product_apaas">
                  <jw-tooltip position="right" mini>
                    <template #content>
                      <p v-for="(item, index) in record.custom?.product_apaas?.split(',')" :key="index">
                        {{ item }}
                      </p>
                    </template>
                    <div class="product-apaas-list">
                      <span v-for="(item, index) in record.custom?.product_apaas?.split(',')" :key="index">
                        <jw-tag bordered style="margin-right: 5px" :color="tagColors?.[index]">
                          {{ item }}
                        </jw-tag>
                      </span>
                    </div>
                  </jw-tooltip>
                </template>
                <template v-else>-</template>
              </template>
              <!-- 最后跟进内容 -->
              <template #lastFollowContent="{ record }">
                <template v-if="record?.lastFollowContent">{{ tools.stripMarkdown(record?.lastFollowContent) }}</template>
                <template v-else>-</template>
              </template>
            </xl-table>
          </jw-tab-pane>
        </jw-tabs>
      </jw-space>
    </jw-modal>
  </div>
</template>
<script setup>
import { reactive, ref } from 'vue';
const visible = ref(false);
import { publicService } from '@/api/';
import useXlTable from '@/hooks/xl-table';
import useFields from '@/hooks/fields.js';
import { tools } from '@/utils/tools';
import { checkboxFieldList } from '@/utils/const';
// 表格表头数据字段
const { enableList, getFields, getFieldLabel } = useFields();
const { tProps, tPropsEvent, setLoadListParams, setTProps, loadTList } = useXlTable(publicService?.setClueRepeat?.bind(publicService));
const { tProps: tPropsCustom, tPropsEvent: tPropsEventCustom, setTProps: setTPropsCustom, loadTList: loadTListCustom, setLoadListParams: setLoadListParamsCustom } = useXlTable(publicService?.setCustomerRepeat?.bind(publicService));
// 设置额外的props
setTProps({
  stickyHeader: 60,
  loading: false
});
setTPropsCustom({
  stickyHeader: 60,
  loading: false
});
const props = defineProps({
  repeat: {
    type: String
  },
  showType: {
    type: Number,
    default: 0
  },
  icon: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: '数据查重'
  }
});
const data = reactive({
  radio: 'companyName',
  type: props.repeat, //1线索2客户
  id: props.repeat, //1线索2客户
  content: '',
  list: [],
  fieldList: [],
  colors: ['#37b41a', 'var(--color-text-2)', 'gold', 'orange', 'gray'], //跟进建议颜色
  columns: [],
  columnsCustom: []
});
const handleCancel = () => {
  visible.value = false;
  reset();
};
const reset = () => {
  data.content = '';
  data.radio = 'companyName';
  console.log(tProps.value.data, 'tProps');
  tProps.value.data = [];
  tPropsCustom.value.data = [];
  tProps.value.pagination.total = 0;
  tPropsCustom.value.pagination.total = 0;
};
const openDialog = async () => {
  visible.value = true;
  getField();
};
const clearContent = () => {
  // data.content = '';
};
const handleOk = async () => {
  // 增加额外参数
  setLoadListParams({
    type: data.radio,
    content: data.content
  });
  setLoadListParamsCustom({
    type: data.radio,
    content: data.content
  });
  tProps.value.pagination.total = 0;
  tPropsCustom.value.pagination.total = 0;
  if (data.type == 1) {
    loadTList();
    loadTListCustom();
  } else {
    loadTListCustom();
  }
  console.log(tProps.value.data, 'tProps');
};
//切换TAB获取表格头部
const changeTab = (key) => {
  data.id = key;
  // getField();
};
// 获取所有字段值,生成表格头部
const getField = async () => {
  await getFields({ id: 1 });
  data.fieldList = enableList.value?.filter((v) => v.fieldKey !== 'parentCustomerId' && v.fieldKey !== 'qccId');
  data.columns = getColumns();
  await getFields({ id: 2 });
  data.fieldList = enableList.value?.filter((v) => v.fieldKey !== 'parentCustomerId' && v.fieldKey !== 'qccId');
  data.columnsCustom = getColumns();
};
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  const fieldList = data.fieldList?.filter((i) => checkboxFieldList?.indexOf(i.fieldKey) == -1);
  console.log(4030, fieldList);
  fieldList?.forEach((item) => {
    const k = item.fieldKey; //字段标识
    const render = ({ record }) => {
      let fieldKey = record?.[k];
      if (item.type === 2) {
        fieldKey = record?.['custom']?.[k];
      }
      if (fieldKey || fieldKey === 0) {
        if (item.fieldType === 9) {
          if (fieldKey && fieldKey !== '{}') {
            return Object.values(JSON.parse(fieldKey))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldKey instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldKey?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldKey, item.fieldExt, item.fieldType);
        } else if (item.fieldType === 12) {
          return fieldKey?.label || '-';
        } else if (item.fieldType === 16) {
          return fieldKey ? fieldKey && tools.getPrice(fieldKey)?.toFixed(item.fieldExt) : '-';
        } else if (item.fieldType === 18) {
          return fieldKey?.label || '-';
        } else {
          return fieldKey?.label ?? fieldKey?.value ?? fieldKey ?? '-';
        }
      } else {
        return '-';
      }
    };

    const colType = {
      title: item.fieldName,
      dataIndex: k,
      ellipsis: true,
      tooltip: true
    };
    if (item.type === 1) {
      colType.colType = '基础字段';
    }
    if (item.type === 2) {
      colType.dataIndex = `${k}Custom`;
    }
    let width = item.fieldName?.length <= 5 ? 120 : item.fieldName?.length * 30;
    if (k === 'customerId') {
      //客户名称 fixed: 'left',
      list.push({ ...colType, slotName: k, width: 200 });
    } else if (k === 'opportunityId') {
      //商机名称
      list.push({ ...colType, slotName: k, width: 200 });
    } else if (k === 'customer_level' || k === 'lastFollowContent ' || k === 'followUser' || k === 'createUser' || k === 'updateUser' || k === 'chargePerson' || k === 'intentionality' || k === 'product_apaas') {
      list.push({ ...colType, slotName: k, width: 180 });
    } else if (k === 'mobile') {
      //手机号
      list.push({ ...colType, width: 140, render });
    } else if (k === 'industry') {
      //行业
      list.push({ ...colType, width: 200, render });
    } else if (k === 'opportunityStage') {
      //行业
      list.push({ ...colType, slotName: k, width: 140 });
    } else {
      if (k === 'dangerous_apaas') {
        width = '120';
      }
      list.push({ ...colType, width, render });
    }
  });
  // console.log(list);
  return list;
};
</script>

<style scoped lang="less">
@import './xl-repeat-button.less';
</style>
<style lang="less">
:deep(.comp-xl-repeat-button) {
  .text-button {
    color: var(--color-text-2);
  }

  .text-button:hover {
    color: rgb(var(--primary-6));
  }
}
</style>
